export default [
  {
    id: "1",
    name: "unBoxed",
    image:
      "https://github.com/JBdunks/unBoxed/blob/master/public/assets/images/unBoxedMain.PNG?raw=true",
    description: "",
    git: "https://github.com/JBdunks/unBoxed",
    deployed: "https://unboxedgaming.herokuapp.com/",
  },
  {
    id: "2",
    name: "R-M-D",
    image:
      "https://github.com/JBdunks/r-m-dir/blob/master/public/rmd.png?raw=true",
    description: "",
    git: "https://github.com/JBdunks/r-m-dir",
    deployed: "https://jbdunks.github.io/r-m-dir/",
  },
  {
    id: "3",
    name: "Burger Time",
    image:
      "https://raw.githubusercontent.com/JBdunks/burger/master/burger_screen.png",
    description: "",
    git: "https://github.com/JBdunks/burger",
    deployed: "https://bobs-burger-time.herokuapp.com/",
  },
  {
    id: "4",
    name: "Food Finder",
    image:
      "https://github.com/JBdunks/FoodFinder/blob/master/foodfinder1.png?raw=true",
    description: "",
    git: "https://github.com/JBdunks/FoodFinder",
    deployed: "https://jbdunks.github.io/FoodFinder/",
  },
  {
    id: "5",
    name: "Weather App",
    image:
      "https://github.com/JBdunks/weather/blob/master/weather_pic.png?raw=true",
    description: "",
    git: "https://github.com/JBdunks/weather",
    deployed: "https://jbdunks.github.io/weather/",
  },
  {
    id: "6",
    name: "Travel-with-Me",
    image:
      "https://github.com/JBdunks/TravelApp/raw/master/client/src/img/picture-5.png",
    description: "",
    git: "https://github.com/JBdunks/TravelApp",
    deployed: "https://travel-with-me.herokuapp.com/",
  },
];
